// extracted by mini-css-extract-plugin
export default {"container":"menuactive_container__WPVvq","navigation":"menuactive_navigation__R+uIe","link":"menuactive_link__vpVKl","active":"menuactive_active__gtuI5"};